import {
    SliderThumb as AriaSliderThumb,
    SliderThumbProps as AriaSliderThumbProps,
} from 'react-aria-components';

import { css } from '@allenai/varnish-panda-runtime/css';

import { cx } from '@/utils/cx';

import sliderRecipe, { SliderRecipeProps } from '@/components/slider/slider.styles';
import focusRing from '@/components/shared/focusRing.styles';

type SliderThumbProps = {
    label?: string;
    className?: string;
} & AriaSliderThumbProps &
    SliderRecipeProps;

const SliderThumb = ({ className, ...rest }: SliderThumbProps) => {
    const [variantProps, localProps] = sliderRecipe.splitVariantProps(rest);
    // `raw` receipe is required to be able to merge css objects (used in focus ring)
    const recipeClassNames = sliderRecipe.raw(variantProps);
    return (
        <AriaSliderThumb
            {...localProps}
            // we need to wrap the `raw` focusRing and `raw` recipeClassNames.thumb in `css()` to merge them
            // there is no garauntee which class will take precidence
            className={cx(css(recipeClassNames.thumb, focusRing), className)}
        />
    );
};

export { SliderThumb, SliderThumb as default };
export type { SliderThumbProps };
